module.exports = __webpack_public_path__ + "../resources/img/ic_complete_number_3_lt.f0bccfb9.svg";